import React, { memo, useCallback, useMemo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import longestLabel from 'Pods/SearchPage/Shared/longestLabel'
import { contentSources, qualityLevels } from 'Pods/SearchPage/Shared/QualityContent/constants'
import QualityContent from 'Pods/SearchPage/Shared/QualityContent/QualityContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearQualityContent } from 'Pods/SearchPage/Store/actions/qualityContent'
import {
  ADVANCED_FILTER, CONTENT_SOURCE, DEFAULT_STATE, QUALITY_LEVEL,
} from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'


function Quality() {
  const translate = useTranslate()

  const quality = useSearchPageStore(state => state.quality)
  const contentSource = useSearchPageStore(state => state.contentSource)
  const hasCgtStandard = useSearchPageStore(
    state => (state.advancedFilters ?? EMPTY_ARRAY).includes(ADVANCED_FILTER.CGT_STANDARD_ONLY),
  )

  const labels = useMemo(() => {
    const levelLabels = Object.fromEntries(qualityLevels.map(level => (
      [level.value, translate(`search_page.filters.quality.levels.${level.labelKey}`)]
    )))
    // Human Created is the default, so "All Content" can be an active value; Figma 2989:109512 reads "All".
    const sourceLabels = Object.fromEntries(contentSources.map(source => (
      [source.value, translate(`search_page.filters.quality.content_source.${
        source.value === CONTENT_SOURCE.ALL ? 'all_short' : source.labelKey
      }`)]
    )))

    return { levelLabels, sourceLabels, cgtStandard: translate('search_page.filters.advanced.cgt_standard') }
  }, [translate])

  const reservedValue = useMemo(() => longestLabel([
    ...Object.values(labels.levelLabels),
    ...Object.values(labels.sourceLabels),
    labels.cgtStandard,
  ]), [labels])

  const selectedValues = useMemo(() => {
    const values = qualityLevels
      .filter(level => level.value !== QUALITY_LEVEL.ANY && quality.includes(level.value))
      .map(level => labels.levelLabels[level.value])

    if (contentSource !== DEFAULT_STATE.contentSource && labels.sourceLabels[contentSource]) {
      values.push(labels.sourceLabels[contentSource])
    }
    if (hasCgtStandard) {
      values.push(labels.cgtStandard)
    }

    return values
  }, [quality, contentSource, hasCgtStandard, labels])
  const hasSelectedAnyFilter = selectedValues.length > 0

  const handleReset = useCallback(() => {
    clearQualityContent()
  }, [])

  const content = useMemo(() => (
    <>
      <QualityContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={translate('search_page.filters.quality.title')}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      selectedValues={selectedValues}
      reservedValue={reservedValue}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Quality)
